<template>
  <div
    :class="[
      'sidebar-area position-fixed start-0 top-0 h-100vh transition',
      { active: stateStoreInstance.open },
    ]"
    id="sidebar-area"
    style="background-color: #861727;"
    v-if="stateStoreInstance.show==true"
  >
    <div class="logo position-absolute start-0 end-0 top-0" style="background-color: #861727;">
      <router-link
        to="/dashboard"
        class="d-flex align-items-center text-white text-decoration-none"
      >
        <img src="../../assets/images/i-money1.jpg" alt="logo-icon" style="max-width:25%;"/>
        <span class="fw-bold ms-10">IZYPAY</span>
      </router-link>
      <div class="border-bottom"></div>
      <button
        class="sidebar-burger-menu position-absolute lh-1 bg-transparent p-0 border-0"
        @click="stateStoreInstance.onChange"
      >
        <i class="ph-duotone ph-caret-double-right"></i>
      </button>
    </div>
    <div class="sidebar-menu">
      <ul
        class="sidebar-navbar-nav ps-0 mb-0 list-unstyled accordion"
        id="sidebarNavAccordion"
      >
        <li class="sidebar-nav-item">
          <router-link to="/dashboard" class="sidebar-nav-link d-block">
            <i class="flaticon-more-1"></i>
            <span class="title">{{ $t('sidebar.dashboard') }}</span>
          </router-link>
        </li>

        <!-- presentation : template au lieu de div, pour rester des enfants directs valides du <ul> -->
        <template v-if="environment=='DEMO'">
          <li class="sidebar-nav-item" v-if="current_permissions('get_transactions')">
            <router-link to="/transactions" class="sidebar-nav-link d-block">
              <i class="flaticon-trolley-cart"></i>
              <span class="title">{{ $t('sidebar.collections') }}</span>
            </router-link>
          </li>
          <li class="sidebar-nav-item" v-if="current_permissions('get_transactions')">
            <router-link to="/transferts" class="sidebar-nav-link d-block">
              <i class="flaticon-money"></i>
              <span class="title">{{ $t('sidebar.payments') }}</span>
            </router-link>
          </li>
        </template>
        <!-- end presentation -->

        <template v-if="environment=='PROD'">
          <li
            class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
            v-if="current_permissions('list_contacts_paginate', 'get_transactions', 'validate_payout_transaction', 'get_bulk_payout_status')"
          >
            <a
              href="#"
              class="accordion-button rounded-0 shadow-none bg-transparent d-block"
              data-bs-toggle="collapse"
              data-bs-target="#sidebarCollapseOne"
              aria-expanded="true"
              aria-controls="sidebarCollapseOne"
            >
              <i class="flaticon-trolley-cart"></i>
              <span class="title">{{ $t('sidebar.transactions') }}</span>
            </a>
            <div
              id="sidebarCollapseOne"
              class="accordion-collapse collapse show"
              data-bs-parent="#sidebarNavAccordion"
            >
              <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('get_transactions')">
                    <router-link to="/transactions" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.collectedPayments') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('get_transactions')">
                    <router-link to="/transferts" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.transfers') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('validate_payout_transaction')">
                    <router-link to="/transferts/default/pending" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.pendingTransfers') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('validate_public_token')">
                    <router-link to="/transferts/validation/one" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.linksToValidateLevel1') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('validate_payout_transaction')">
                    <router-link to="/transferts/validation/two" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.linksToValidateLevel2') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_contact_books')">
                    <router-link to="/contacts" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.contacts') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li v-if="current_permissions('list_organizations')"
            class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          >
            <a
              href="#"
              class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              data-bs-toggle="collapse"
              data-bs-target="#sidebarCollapseTwo"
              aria-expanded="false"
              aria-controls="sidebarCollapseTwo"
            >
              <i class="flaticon-rocket"></i>
              <span class="title">{{ $t('sidebar.crm') }}</span>
            </a>
            <div
              id="sidebarCollapseTwo"
              class="accordion-collapse collapse"
              data-bs-parent="#sidebarNavAccordion"
            >
              <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_organizations')">
                    <router-link
                      to="/crm-customers"
                      class="sidebar-sub-menu-link"
                    >
                      {{ $t('sidebar.organizations') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <!-- <li class="sidebar-nav-item" v-if="current_permissions('list_users')">
            <router-link :to="`/utilisateurs/${code}`" class="sidebar-nav-link d-block">
              <i class="flaticon-people"></i>
              <span class="title">{{ $t('sidebar.users') }}</span>
            </router-link>
          </li> -->

          <!-- revocation -->

          <li v-if="current_permissions('list_users')"
            class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          >
            <a
              href="#"
              class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              data-bs-toggle="collapse"
              data-bs-target="#sidebarCollapseTwo"
              aria-expanded="false"
              aria-controls="sidebarCollapseTwo"
            >
              <i class="flaticon-people"></i>
              <span class="title">Gestion utilisateurs</span>
            </a>
            <div
              id="sidebarCollapseTwo"
              class="accordion-collapse collapse"
              data-bs-parent="#sidebarNavAccordion"
            >
              <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_users')">
                    <router-link
                      :to="`/utilisateurs/${code}`"
                      class="sidebar-sub-menu-link"
                    >
                      <span class="title">{{ $t('sidebar.users') }}</span>
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('token_session_list')">
                    <router-link
                      to="/token-list"
                      class="sidebar-sub-menu-link"
                    >
                      Liste des sessions
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('revoke_token')">
                    <router-link
                      to="/token-list"
                      class="sidebar-sub-menu-link"
                    >
                      Revoquer son token
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('revoke_token_session')">
                    <router-link
                      to="/crm-customers"
                      class="sidebar-sub-menu-link"
                    >
                      Revoquer autre token
                    </router-link>
                  </li>
                </ul>
              </div> -->
            </div>
          </li>
          <!-- // revocation -->

          <li class="sidebar-nav-item" v-if="current_permissions('list_accounts')">
            <router-link :to="`/account/${code}`" class="sidebar-nav-link d-block">
              <i class="flaticon-bag"></i>
              <span class="title">{{ $t('sidebar.myAccounts') }}</span>
            </router-link>
          </li>

          <li v-if="current_permissions('list_repayments','list_topups', 'list_business', 'list_providers','global_report')"
            class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          >
            <a
              href="#"
              class="accordion-button rounded-0 shadow-none bg-transparent d-block"
              data-bs-toggle="collapse"
              data-bs-target="#sidebarCollapseThree"
              aria-expanded="true"
              aria-controls="sidebarCollapseThree"
            >
              <i class="flaticon-money"></i>
              <span class="title">{{ $t('sidebar.finances') }}</span>
            </a>
            <div
              id="sidebarCollapseThree"
              class="accordion-collapse collapse show"
              data-bs-parent="#sidebarNavAccordion"
            >
              <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_repayments')">
                    <router-link to="/repayment" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.refunds') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_topups')">
                    <router-link to="/reloading" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.reloads') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_business')">
                    <router-link to="/business" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.business') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_providers')">
                    <router-link to="/balance" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.balance') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('global_report')">
                    <router-link to="/export" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.operationsStatement') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li
            v-if="current_permissions('list_extended_merchant_accounts')"
            class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          >
            <a
              href="#"
              class="accordion-button collapsed rounded-0 shadow-none bg-transparent d-block"
              data-bs-toggle="collapse"
              data-bs-target="#sidebarCollapseLedger"
              aria-expanded="false"
              aria-controls="sidebarCollapseLedger"
            >
              <i class="flaticon-bag"></i>
              <span class="title">Ledger</span>
            </a>
            <div
              id="sidebarCollapseLedger"
              class="accordion-collapse collapse"
              data-bs-parent="#sidebarNavAccordion"
            >
              <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_extended_merchant_accounts')">
                    <router-link to="/ledger/accounts" class="sidebar-sub-menu-link">
                      Liste des comptes
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_double_entries')">
                    <router-link to="/ledger/doublewrite" class="sidebar-sub-menu-link">
                      Écriture double entrée
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <li
            v-if="current_permissions('list_countries', 'list_typeFees', 'list_fees', 'list_providers','public_list_operators','create_all_config','list_operators' )"
            class="sidebar-nav-item accordion-item bg-transparent border-0 rounded-0"
          >
            <a
              href="#"
              class="accordion-button rounded-0 shadow-none bg-transparent d-block"
              data-bs-toggle="collapse"
              data-bs-target="#sidebarCollapseFour"
              aria-expanded="true"
              aria-controls="sidebarCollapseFour"
            >
              <i class="flaticon-setting"></i>
              <span class="title">{{ $t('sidebar.settings') }}</span>
            </a>
            <div
              id="sidebarCollapseFour"
              class="accordion-collapse collapse show"
              data-bs-parent="#sidebarNavAccordion"
            >
              <div class="accordion-body">
                <ul class="sidebar-sub-menu ps-0 mb-0 list-unstyled">
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_countries')">
                    <router-link to="/country" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.countries') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_typeFees')">
                    <router-link to="/typefree" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.feeTypes') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_fees')">
                    <router-link to="/fee" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.fees') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_providers')">
                    <router-link to="/providor" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.providers') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_operators')">
                    <router-link to="/operator" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.operators') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_permissions')">
                    <router-link to="/permissions" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.permissions') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_actions')">
                    <router-link to="/actions" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.actions') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_configs')">
                    <router-link to="/general-setting" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.accountConfiguration') }}
                    </router-link>
                  </li>
                  <li class="sidebar-sub-menu-item" v-if="current_permissions('list_configs')">
                    <router-link to="/config" class="sidebar-sub-menu-link">
                      {{ $t('sidebar.settingsConfiguration') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </template>

        <li class="sidebar-nav-item">
          <router-link to="/" @click.prevent="logout(backApi)" class="sidebar-nav-link d-block">
            <i class="flaticon-logout"></i>
            <span class="title">{{ $t('sidebar.logout') }}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, inject, ref, onMounted, onBeforeUnmount } from "vue";

import { useI18n } from "vue-i18n";
import stateStore from "../../utils/store";
import router from '../../router/index'
import { current_permissions } from '../../utils/permission';
import { logout } from '../../utils/function';

export default defineComponent({
  name: "MainSidebar",
  setup() {
  const backApi = inject('back');
  const { t } = useI18n();
  let environment = process.env.VUE_APP_TEST;
  const code = ref(localStorage.getItem('organization_code'));

  const refreshCode = () => {
    code.value = localStorage.getItem('organization_code');
  };

  onMounted(() => {
    window.addEventListener('user-login', refreshCode);
    console.log('get_transactions:', current_permissions('get_transactions'));
    console.log('list_contacts_paginate:', current_permissions('trois_gangs'));
  });

  onBeforeUnmount(() => {
    window.removeEventListener('user-login', refreshCode);
  });

  const stateStoreInstance = stateStore;

  return {
    stateStoreInstance,
    logout,
    code,
    environment,
    current_permissions,
    backApi,
  };
}
});
</script>